import '../vendor/select2.min.js';
// import * as Flatpickr from "flatpickr";
// import { Dutch } from "flatpickr/dist/l10n/nl.js";
import { Filter } from '../modules/archive-filter.js';
import { lockScroll } from '../modules/lockScroll.js';

var agenda = {},
		field = {},
		overlay = {
			busy: false,
			active: true
		},
		filter = {}

function detectIE() {
	var ua = window.navigator.userAgent;
	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}
	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}
	// var edge = ua.indexOf('Edge/');
	// if (edge > 0) {
	// 	// Edge (IE 12+) => return version number
	// 	return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	// }
	return false;
}

function hasPointer() {
	if (detectIE() !== false) {
		// Test pointer fine werkt niet in IE11;
		// Aanname is dat pointer ondersteund wordt
		// Want IEMobile wordt wereldwijd amper gebruikt
		return true;
	} else if (matchMedia('(pointer:fine)').matches) {
		return true;
	} else {
		return false;
	}
}

function isMobile() {
	if (Modernizr.mq('(max-width: 1023px)')) {
		return true;
	} else {
		return false;
	}
}

field.select = () => {
	if (hasPointer()) {
		$('.select2').select2({
			dropdownAutoWidth: false,
			// allowClear: true
		});
		$('select.select2').attr('tabindex', '0');
		$('.select2').on('select2:open', function (e) {
			e.preventDefault();
			let $field = $(this).closest('.el-field'),
					width = $field.width();
			$field.addClass('is-active');
			$('.select2-container .select2-dropdown').css({width : width});
			if ($('.el-fake-select.is-datepicker').closest('.el-field').hasClass('is-active')) {
				$('.el-fake-select.is-datepicker').closest('.el-field').removeClass('is-active');
				$('.select2-container .select2-dropdown').css({width : width});
			}
			setTimeout(function() {
				$('.select2-container .select2-dropdown').css({width : width});
			}, 10);
		});
		$('.select2').on('select2:close', function (e) {
			e.preventDefault();
			let $field = $(this).closest('.el-field');
			$field.removeClass('is-active');
		});
		$('.select2').on('select2:select', function (e) {
			let data = $(this).select2('data');

			if ( 'undefined' != typeof data[0] ) {
				if ( 'archive' == data[0].element.getAttribute('data-taxonomy') ) {
					e.preventDefault();
					// goto page
					console.log( data[0].element.getAttribute('data-redirect'));
					if ( data[0].element.getAttribute('data-redirect') != null ) {
						window.location = data[0].element.getAttribute('data-redirect');
						return false
					} else if ( 'undefined' != typeof customData.agendaPath ) {
						window.location = customData.agendaPath + data[0].id;
						return false
					}
				}
			}

			if ( ! isMobile() ) {
				// Filter.update_filter('to', null);
				filter.update_filter( $(this), data );
				// console.log('update filter: ' + field + ' = ' + value);
			} else {
				// console.log('via submit updaten');
			}
		});
	}
}

/*
field.datepicker = () => {
	$('.el-fake-select.is-datepicker').click(function(e){
		e.preventDefault();
		let $field = $(this).closest('.el-field');
		if (!$field.hasClass('is-active')) {
			$field.addClass('is-active');
		} else {
			$field.removeClass('is-active');
		}
	});
	flatpickr("#datepicker .flatpickr", {
		locale: Dutch,
		inline: true,
		prevArrow: '<span class="svg-icon icon-prev" data-icon="icon-arrow-small" data-rotate="90"></span>',
		nextArrow: '<span class="svg-icon icon-next" data-icon="icon-arrow-small" data-rotate="-90"></span>',
		dateFormat: "Y-m-d",
		mode: 'range',
		appendTo: '#datepicker',
		enableTime: false,
		enableSeconds: false,
		maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 2)),
		minDate: "today",
		// defaultDate
		onReady: (selectedDates, dateStr, instance) => {
			$('body').icons.init('.svg-icon', $('#datepicker'));
		},
		onChange: (selectedDates, dateStr, instance) => {
			$('body').icons.init('.svg-icon', $('#datepicker'));
			if (!isMobile()) {
				console.log('update filter: ' + dateStr);
			} else {
				// console.log('via submit updaten');
			}
		}
	});
}
*/

field.submit = () => {
	$('#agenda .js-submit-filter').click(function(e){
		e.preventDefault();
		if (isMobile()) {
			var data = $('#agenda .filter').serialize();
			data.split('&').forEach( function( part ) {
				let item = part.split('=');
				filter.agendaFilter.active_params[ item[0] ][ 0 ] = item[1];
			});
			filter.update_filter();
			overlay.close();
		}
	});
}

overlay.open = () => {
	if (overlay.busy == false) {
		overlay.busy = true;
		overlay.active = true;
		$('#agenda .filter').addClass('is-active');
		setTimeout(function() {
			$('#sitewide, #sitewide-beam').addClass('is-inactive');
			lockScroll.init(true);
			overlay.busy = false;
		}, 850);
	}
}

overlay.close = () => {
	if (overlay.busy == false) {
		overlay.busy = true;
		overlay.active = false;
		$('#sitewide, #sitewide-beam').removeClass('is-inactive');
		$('#agenda .filter').removeClass('is-active');
		lockScroll.init(false);
		setTimeout(function() {
			overlay.busy = false;
		}, 500);
	}
}

overlay.init = () => {
	$('#agenda .js-open-filter').click((e) => {
		e.preventDefault();
		overlay.open();
	});
	$('#agenda .js-close-filter').click(function(e) {
		e.preventDefault();
		overlay.close();
	});
}

filter = {
	agendaFilter: Filter,
	agendaFilterSelection: '.filter-selection',
	init: function() {
		window.onload = () => {
			Filter.DOMContentLoaded();
			if (this.agendaFilter.current_url.indexOf("?") > -1) {
        filter.prepare_filter_selection();
      }
		};
		document.addEventListener('Archive_Filter_Loading', function (event) {
			$('#agenda .agenda-loader').addClass('is-active');
			event.loading_html = '';
		});
		document.addEventListener('Archive_Filter_After', function (event) {
			// update icons after update
			$('body').icons.init('.svg-icon', $('#agenda .el-pagination ul li a'));
			filter.done_loading();
			aSync.initTicketsPopUp();
		});

		$('#agenda .js-reset-filter').click((e) => {
			e.preventDefault();
			$('.select2').each(function(){
				$(this).val('').trigger('change');
				$(this).find('.active').removeClass('active');
			});
			document.getElementById('agenda-filter').reset();
			filter.reset_filter();
		});
	},

	update_filter: function( e, data ) {
		let field = null;
		let value = null;
		if ( 'undefined' != typeof e ) {
			field = e.closest('select').attr('name');
			delete this.agendaFilter.active_params[ field ];
		}
		if ( 'undefined' != typeof data && data.length > 0 ) {
			value = data[0].id;
		}
		this.agendaFilter.update_filter( field, value );
		filter.prepare_filter_selection();
	},

	prepare_filter_selection: function() {
		if ( 'undefined' != typeof this.agendaFilter.active_params ) {
			let active_filters = false;
			let html_li = '';
			for ( var field in this.agendaFilter.active_params ) {
				if ( this.agendaFilter.active_params[ field ].length > 0 ) {
					active_filters = true;
					let value = this.agendaFilter.active_params[ field ];
					let label = value;
					if ( $('#agenda option[value="' + value + '"]').length > 0 ) {
						label = $('#agenda option[value="' + value + '"]').text();
						if ( 'wanneer' == field && $('#agenda option[value="' + value + '"]').closest('optgroup').length > 0 ) {
							label+= ' ' + $('#agenda option[value="' + value + '"]').closest('optgroup').attr('label');
						}
					}
					html_li+= '' +
						'<li data-type="' + field + '"><a href="' + filter.parse_url( field ) + '">' +
							'<span class="text">' + label + '</span>' +
							'<span class="svg-icon" data-icon="icon-close" data-offset="8"></span></a>' +
						'</li>';
				}
			}
			// always update DOM
			$( filter.agendaFilterSelection + ' ul').empty().append( html_li );
			if ( active_filters ) {
				$( filter.agendaFilterSelection ).addClass('is-active');
				$('body').icons.init('.svg-icon', $( filter.agendaFilterSelection + ' ul li'));
			} else {
				$( filter.agendaFilterSelection ).removeClass('is-active');
			}
		} else {
			$( filter.agendaFilterSelection ).removeClass('is-active');
		}
	},

	parse_url: function( field ) {
		let new_url     = location.pathname;
		let current_url = location.search;
		let params      = current_url.substr(1);
		let result      = [];

		params.split('&').forEach( function( part ) {
			let item = part.split('=');
			if ( field == item[0] ) {
				return;
			}
			result[ result.length ] = part;
		});

		if ( result.length > 0 ) {
			new_url += '?' + result.join('&');
		}

		return new_url;
	},

	reset_filter: function() {
		if ( Object.keys( this.agendaFilter.active_params ).length > 0 ) {
			this.agendaFilter.DOMContentLoaded();
			filter.update_filter();
			// setTimeout(function(){
			// 	filter.done_loading();
			// }, 1000 );
			// filter.prepare_filter_selection();
		}
	},

	done_loading: function() {
		$('#agenda .agenda-loader').removeClass('is-active');
	}
}

agenda.init = () => {
	field.select();
	// field.datepicker();
	field.submit();
	overlay.init();
	// init filter
	filter.init();
}

export { agenda };
